import { MachinePart } from 'models/MachinePart';
import { ApiPayload } from 'infrastructure/api/ApiTypes';
import { Api } from 'infrastructure/api/Api'

export const MachinePartActionType = {
    FETCH_MACHINEPARTS: 'FETCH_MACHINEPARTS',
    FETCH_MACHINEPARTS_SUCCESS: 'FETCH_MACHINEPARTS_SUCCESS',
    ADD_MACHINEPART: 'ADD_MACHINEPART',
    ADD_MACHINEPART_SUCCESS: 'ADD_MACHINEPART_SUCCESS',
    EDIT_MACHINEPART: 'EDIT_MACHINEPART',
    EDIT_MACHINEPART_SUCCESS: 'EDIT_MACHINEPART_SUCCESS',
    DELETE_MACHINEPART: 'DELETE_MACHINEPART',
    DELETE_MACHINEPART_SUCCESS: 'DELETE_MACHINEPART_SUCCESS',
    API_ERROR: 'API_ERROR',
};

interface IFetchMachinePartsAction {
    type: typeof MachinePartActionType.FETCH_MACHINEPARTS
    payload: ApiPayload,
    returnPayload: MachinePart[],
    meta: {
        isApiCall: boolean
    },
}

interface IAddMachinePartsAction {
    type: typeof MachinePartActionType.ADD_MACHINEPART
    payload: ApiPayload,
    returnPayload: MachinePart,
    meta: {
        isApiCall: boolean
    },
}

interface IDeleteMachinePartsAction {
    type: typeof MachinePartActionType.DELETE_MACHINEPART
    payload: ApiPayload,
    returnPayload: MachinePart,
    meta: {
        isApiCall: boolean
    },
}

export type IMachinePartActions = IFetchMachinePartsAction | IAddMachinePartsAction | IDeleteMachinePartsAction

const baseUrl = 'api/machineParts';
export class MachinePartActions {
    public static fetchMachineParts(token: string): IMachinePartActions {
        return {
            type: MachinePartActionType.FETCH_MACHINEPARTS,
            payload: Api.fetchApiCall(baseUrl, token, MachinePartActionType.FETCH_MACHINEPARTS_SUCCESS, MachinePartActionType.API_ERROR),
            returnPayload: [],
            meta: {
                isApiCall: true
            },
        }
    }

    public static addMachinePart(token: string, machinePart: MachinePart): IMachinePartActions {
        return {
            type: MachinePartActionType.ADD_MACHINEPART,
            payload: Api.postApiCall(baseUrl, token, MachinePartActionType.ADD_MACHINEPART_SUCCESS, MachinePartActionType.API_ERROR, machinePart),
            returnPayload: MachinePart.empty(),
            meta: {
                isApiCall: true
            },
        }
    }

    public static editMachinePart(token: string, machinePart: MachinePart): IMachinePartActions {
        return {
            type: MachinePartActionType.EDIT_MACHINEPART,
            payload: Api.putApiCall(baseUrl + '/' + machinePart.id, token, MachinePartActionType.EDIT_MACHINEPART_SUCCESS, MachinePartActionType.API_ERROR, machinePart),
            returnPayload: MachinePart.empty(),
            meta: {
                isApiCall: true
            },
        }
    }

    public static deleteMachinePart(token: string, id: number): IMachinePartActions {
        return {
            type: MachinePartActionType.DELETE_MACHINEPART,
            payload: Api.deleteApiCall(baseUrl + '/' + id, token, MachinePartActionType.DELETE_MACHINEPART_SUCCESS, MachinePartActionType.API_ERROR, true),
            returnPayload: MachinePart.empty(),
            meta: {
                isApiCall: true
            },
        }
    }

}
